// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__TyY6A","title":"Images90_title__36jdL","images":"Images90_images__2KOTi"};